import * as svg from "../../../assets/calendar-icon.svg";

import {iconBuilder} from "./iconBuilder";

const CalendarIcon = iconBuilder(svg, "CalendarIcon", "0 0 21 21");

export default CalendarIcon;
